import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDefaultChartOfAccounts = () => {
  return axios.get(`/default-chart-of-accounts`);
};

export const useDefaultChartOfAccounts = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["default-chart-of-accounts"],
    queryFn: () => getDefaultChartOfAccounts(),
    select: data => data.result
  });
};
